export class SessionTimeoutEvent extends Event {
   static EVENT_NAME = 'atlantis-session-timeout';
   constructor() {
      super(SessionTimeoutEvent.EVENT_NAME, { bubbles: true, composed: true });
   }
}
